import { SidebarIconProps } from "../../../types";

export default function ProposalsIcon({ collapsed }: SidebarIconProps) {
  return (
    <span className="w-6 flex justify-center">
      <svg
        width="16"
        height="13"
        viewBox="0 0 16 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={collapsed ? "" : "relative left-[3px]"}
      >
        <path
          d="M0.75 10.9995H5.125M8.25 9.12455L11.375 12.2495M11.375 12.2495L14.4999 9.12502M11.375 12.2495L11.375 4.74951M0.75 5.99951H6.37492M0.75 0.999512H11.3749"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
